<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete"
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewRules" class="btn btn-primary">
              Create Rules
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert 
            :type="message.type" 
            :dismissible="true"
            @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
            <template slot="default_rule_column" slot-scope="props">
              <label v-if="props.cell_value == 0"> False </label>
              <label v-if="props.cell_value == 1"> True </label>
            </template>
             <template slot="is_slice_free_spin_column" slot-scope="props">
              <label v-if="props.cell_value == 0"> False </label>
              <label v-if="props.cell_value == 1"> True </label>
            </template>
             <template slot="is_slice_try_again_column" slot-scope="props">
              <label v-if="props.cell_value == 0"> False </label>
              <label v-if="props.cell_value == 1"> True </label>
            </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.rules_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Rules Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select Brand"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
          <div class="col-lg-6">
            <label class="form-control-label"> Promotion Type</label>
            <model-list-select
              :list="allPromoType"
              v-model="watch_promo_type"
              option-value="value"
              option-text="text"
              placeholder="select promo type"
              :isDisabled="isPromoTypeDisabled"
            >
            </model-list-select>      
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="issub_promo_typeShow">
            <label class="form-control-label">Sub Promotion Type</label>
            <model-list-select
              :list="selectedSubPromoType"
              v-model="watch_sub_promo_type"
              option-value="value"
              option-text="text"
              placeholder="select sub promo type"
              :isDisabled="issubPromoTypeDisabled"
            >
            </model-list-select>      
          </div>
          <div class="col-lg-6" v-if="isInputCountShow">
            <base-input
              alternative=""
              label="Input Count"
              input-classes="form-control"
              v-model="rulesModel.input_count"
              type="number"
              @input="validateInputCountDailyLogin"
            />
          </div>          
        </div>
        <div class="row">
          <label class="form-control-label" v-if="isLabelDoubleSpinWheelWarningShow" style="color:red; padding-left:15px;">
            (Rules name will be filled automatically with Group Outer & Group Inner value)</label>
          <div class="col-lg-6" v-if="isGroupOuterShow">
            <base-input
              alternative=""
              :label="groupOuterLabel"
              input-classes="form-control"
              v-model="rulesModel.group_outer"
              type="text"
              @change="onGroupChange"
            />
          </div>
          <div class="col-lg-6" v-if="isGroupInnerShow">
            <base-input
              alternative=""
              label="Group Inner"
              input-classes="form-control"
              v-model="rulesModel.group_inner"
              type="text"
              @change="onGroupChange"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label class="form-control-label" style="color: red; padding-left:15px;" v-if="isGroupColorHexWarning">Group Outer Color and Group Inner Color must be valid hex (e.g. #FF0000 or #F00)</label>
          </div>
          <div class="col-lg-6" v-if="isGroupOuterColorShow">
            <base-input
              alternative=""
              label="Group Outer Color"
              input-classes="form-control"
              v-model="rulesModel.outer_group_color"
              type="text"
              :required="isGroupOuterColorShow"
            />
          </div>
          <div class="col-lg-6" v-if="isGroupInnerColorShow">
            <base-input
              alternative=""
              label="Group Inner Color"
              input-classes="form-control"
              v-model="rulesModel.inner_group_color"
              type="text"
              :required="isGroupInnerColorShow"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Rules Name"
              input-classes="form-control"
              v-model="rulesModel.rules_name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Description"
              input-classes="form-control"
              v-model="rulesModel.description"
            />
          </div>
        </div> 
        <div class="row">
          <div class="col-lg-12" v-if="this.isGracePeriodShow">
            <base-input 
             alternative=""
             label="Grace Period" 
             input-classes="form-control"
             v-model="rulesModel.grace_period"
             type="number" 
             :min="0" 
             :max="30" 
             @input="limitGracePeriod"/>
          </div>
        </div> 
        <div class="row">
          <div class="col-lg-6" v-if="isDeductionShow">
            <base-input
              alternative=""
              label="Deducted Amount"
              input-classes="form-control"
              v-model="rulesModel.deducted_amount"
              type="number"
            />
          </div>
          <div class="col-lg-6" v-if="isProbabilityShow">
            <base-input
              alternative=""
              label="Probability"
              input-classes="form-control"
              v-model="rulesModel.probability"
              type="number"
              @input="restrictDecimal"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="isWinLimitShow">
            <base-input
              alternative=""
              label="Win Limit"
              input-classes="form-control"
              v-model="rulesModel.win_limit"
              type="number"
              :disabled="isWinLimitDisabled"
            />
          </div>
          <div class="col-lg-6" v-if="isWinLimitPerPersonShow">
            <base-input
              alternative=""
              label="Win Limit Per Person"
              input-classes="form-control"
              v-model="rulesModel.win_limit_per_person"
              type="number"
              :disabled="isWinLimitPerPersonDisabled"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="isCampaignIdentifierShow">
            <base-input
              alternative=""
              label="Campaign Identifier"
              input-classes="form-control"
              v-model="rulesModel.campaign_identifier"
              :disabled="isCampaignIdentifierDisabled"
            />
          </div>
           <div class="col-lg-6" v-if="isLastLoginDateShow">
            <!-- <base-input
              alternative=""
              label="Last Login Date"
              input-classes="form-control"
              v-model="rulesModel.last_login_date"
            /> -->
            <div class="form-group has-label">
             <label class="form-control-label"> Last Login Date </label>
             <date-picker
                v-model="lastLoginDate"
                editable
                clearable
                value-type="YYYY-MM-DD"
                id="LastLoginDate"
                :default-value="lastLoginDate"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
          <div class="col-lg-6" v-if="isTargetRefferalCountShow">
            <base-input
              alternative=""
              label="Target Refferal Count"
              input-classes="form-control"
              v-model="rulesModel.target_refferal_count"
              type="number"
            />
          </div>
        </div>
        <div>
          <div class="row" v-if="isDefaultRuleShow">
            <div class="col-lg-12">
              <label class="form-control-label"> 
                {{ defaultRuleLabel }}
              </label>
              <small>{{ defaultRuleDescription }}</small>
                <base-checkbox
                  alternative=""
                  input-classes="form-control"
                  v-model="rulesModel.default_rule"
                  value="false"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12" v-if="isSliceFreeSpinShow">
              <label class="form-control-label"> Is Slice Free Spin <small>(only applicable for Promo Type Spin Wheel and will not deducting maximum chance per day)</small> </label>
                <base-checkbox
                  alternative=""
                  input-classes="form-control"
                  v-model="rulesModel.is_slice_free_spin"
                  value="false"
                  :disabled="rulesModel.is_slice_try_again"
                  :changed="isPrizeTypeNoReward(isNoRewardGroupValue)"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12" v-if="isSliceTryAgainShow">
              <label class="form-control-label"> Is Slice Try Again </label>
                <base-checkbox
                  alternative=""
                  input-classes="form-control"
                  v-model="rulesModel.is_slice_try_again"
                  value="false"
                  :disabled="rulesModel.is_slice_free_spin"
                  :changed="isPrizeTypeNoReward(isNoRewardGroupValue)"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6" v-if="isinputImageShow">
              <base-input
                id="inputImage"
                label="Image"
                input-classes="form-control"
                type="file"
                accept="image/*"
                @change="onFileChange($event)"
              />
              <div v-if="uploadModel.image_url">
                <img :src="uploadModel.image_url" class="img img-thumbnail" />
              </div>
              <div v-else>
                <img :src="rulesModel.image_url" class="img img-thumbnail" />
              </div>
            </div>
            <div class="col-lg-6" v-if="isTargetDonationAmountShow">
              <base-input
                alternative=""
                label="Target Donation Amount"
                input-classes="form-control"
                v-model="rulesModel.target_donation_amount"
                type="number"
                value="false"
              />
            </div>
          </div>          
        </div>
        <div class="row" v-if="isFlashPromoShow">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label"> Flash Promo </label>
              <model-list-select
                :list="FlashPromoConfigs"
                v-model="rulesModel.flash_promo_id"
                option-value="id"
                option-text="promotion_name"
                placeholder="Select Flash Promo"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-lg-6" v-if="isinputPrizeShow">
            <label class="form-control-label"> Prize </label>
            <multiselect
              v-model="MajorPrizeValue"
              tag-placeholder="Add this as Prize"
              placeholder="Search or add Prize"
              label="prize_name"
              track-by="id"
              :options="MajorPrizesOption"
              :multiple="true"
              :taggable="true"
              @remove="unSelectMjrPrize"
            >
            </multiselect>
          </div>
          <div class="col-lg-6" v-if="isInputSpecialPrizeShow">
            <label class="form-control-label"> Special Prize </label>
            <multiselect
              v-model="SpecialPrizeValues"
              tag-placeholder="Add this as Special Prize"
              placeholder="Search or add Special Prize"
              label="sku_name"
              track-by="id"
              :options="SpecialPrizeOptions"
              :multiple="true"
              :taggable="true"
              @remove="unSelectSpecialPrizes"
            >
            </multiselect>
          </div>
          <div class="col-lg-6" v-if="isRankShow">
            <base-input
              alternative=""
              label="Rank"
              input-classes="form-control"
              v-model="rulesModel.rank"
              type="number"
              :min="1" 
              :max="99" 
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="isSelectIconShow">
            <base-input
              id="inputIcon"
              label="Icon"
              input-classes="form-control"
              type="file"
              accept="image/*"
              @change="onSelectIconChange($event)"
            />
            <div v-if="uploadIconModel.icon_url">
              <img :src="uploadIconModel.icon_url" class="img img-thumbnail" />
            </div>
            <div v-else>
              <img :src="rulesModel.icon_url" class="img img-thumbnail"/>
            </div>
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdateRules"
          class="btn btn-primary"
          v-bind:disabled="disableButtonSubmit"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import Multiselect from "vue-multiselect";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";
import NProgress from "nprogress";

export default {
  name: "RulesItemList",
  data() {
    return {
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      uploadModel: {
        image_url: null,
        imagePresignedUrl: "",
        imageFile: null,
      },
      uploadIconModel:{
        icon_url: null,
        iconPresignedUrl: "",
        iconFile: null,
      },
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      isBrandCodeDisabled: false,
      isPromoTypeDisabled: false,
      issubPromoTypeDisabled: false,
      isInputSpecialPrize: false,
      isInputSpecialPrizeShow: false,
      isEdit: false,
      isDeductionShow:true,
      isProbabilityShow:true,
      isWinLimitShow:true,
      isCampaignIdentifierShow:false,
      isInputCountShow:false,
      issub_promo_typeShow:false,
      isLastLoginDateShow:false,
      isTargetRefferalCountShow:false,
      isWinLimitPerPersonShow:true,
      isDefaultRuleShow:false,
      isSliceFreeSpinShow:false,
      isSliceTryAgainShow:false,
      isTargetDonationAmountShow:false,
      isinputPrizeShow:true,
      isinputImageShow:true,
      isFlashPromoShow:false,
      isGracePeriodShow: false,
      isWinLimitPerPersonDisabled: false,
      isWinLimitDisabled: false,
      isGroupOuterShow: false,
      isGroupInnerShow: false,
      isGroupOuterColorShow: false,
      isGroupInnerColorShow: false,
      isSelectIconShow: false,
      isLabelDoubleSpinWheelWarningShow: false,
      isRankShow: false,
      titlePopup: "Create",
      groupOuterLabel: "Group Outer",
      message: null,
      watch_promo_type : "",
      watch_sub_promo_type : "",
      isCampaignIdentifierDisabled: false,
      allPromoType: [
        { text: "UGC Artwork Image", value: '0' },
        { text: "UGC Artwork Image - Vote Approved", value: '1' },
        { text: "Spin Wheel - Custom Prize", value: '2' },
        { text: "UPC Input - Lifetime", value: '3' },
        { text: "UPC Custom Insert", value: '4' },
        { text: "MGM Major Prize", value: '5' },
        { text: "MGM Minor Prize", value: '6' },
        { text: "Custom Returnee", value: '7' },
        { text: "Donations", value: '8' },
        { text: "UPC Input Regular", value: '9' },
        { text: "Cash or Bukash", value: '11' },
        { text: "Progressive MGM", value: '12' },
        { text: "Redeem Item", value: '13' },
        { text: "Lucky Promo", value: '14' },
        { text: "Roulette", value: '15' },
        { text: "Daily Login", value: '16' },
        { text: "Auto Awarding Birthday User", value: '17' },
        { text: "Auto Awarding Anniversary", value: '18' },
        { text: "Double SpinWheel", value: '19' },
        { text: "Redeem Item On Event", value: '20' },
        { text: "Daily Check In", value: '25' },
        { text: "Beats Game", value: '30' },
        { text: "Catch Game", value: '31' },
        { text: "Chest Prize", value: '40' },
        { text: "Lucky Promo With SKU", value: '45' },
        { text: "UPC Custom Insert With Raffle", value: '50' }
        ],
      allsubPromoType: [
        { text: "UPCRegular", value: '0', promotype:['9'] },
        { text: "UPCTracker", value: '1', promotype:['9'] },
        { text: "Progressive MGM Minor Prize", value: '2', promotype:['12'] },
        { text: "Progressive MGM Major Prize", value: '3', promotype:['12'] },
        { text: "Daily Login Reguler", value: '4', promotype:['16'] },
        { text: "Daily Login Special", value: '5', promotype: ['16'] },
        { text: "Daily Check In Reguler", value: '10', promotype:['25'] },
        { text: "Daily Check In Special", value: '11', promotype:['25'] },
        { text: "Leaderboard Winner", value: '6', promotype: ['30', '31'] },
        { text: "Leaderboard Reserve Winner", value: '7', promotype: ['30', '31'] },
        { text: "Completion", value: '8', promotype: ['30', '31'] }
      ],
      selectedSubPromoType: [],      
      rulesModel: {
        brand_code: "PHFortune",
        promotion_type: "",
        sub_promotion_type: "",
        rules_name: "",
        deducted_amount: 0,
        probability: 0,
        win_limit: 0,
        win_limit_per_person: 0,
        target_refferal_count:0,
        campaign_identifier:"",
        default_rule: false,
        default_rule_flag: 0,
        input_count: 1,
        is_slice_free_spin: false,
        is_slice_free_spin_flag: 0,
        is_slice_try_again: false,
        is_slice_try_again_flag: 0,
        description: "",
        image_url: "",
        target_donation_amount:0,
        flash_promo_id: "",
        major_prizes_id_list:[],
        addition_major_prizes_id_list:[],
        removal_major_prizes_id_list:[],
        last_login_date: new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        special_prize_condition_ids: "",
        special_prize_condition_id_list: [],
        grace_period: 0,
        group_outer: "",
        group_inner: "",
        outer_group_color: "",
        inner_group_color: "",
        icon_url: "",
        rank: 1
      },
      lastLoginDate: new Date().toISOString(),
      FlashPromoConfigs: [],
      MajorPrizesAllOption: [],
      MajorPrizesOption: [],
      MajorPrizesNoRewardOption: [],
      MajorPrizeValue: [],
      SpecialPrizeValues: [],
      SpecialPrizeOptions : [],
      unSelectSpecialPrizes : [],
      unSelectedMjrPrize:[],
      unSelectedMnrPrize:[],
      majorPrizeName:[],
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allRulesConfigs: null,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Promotion Type Name",
          name: "promotion_type_name",
          sort: true,
          filter: {
            type: "simple",
            placeholder: "Enter Promotion Type Name",
            case_sensitive: false, // "false" by default
            showClearButton: true,
            filterOnPressEnter: false,
            debounceRate: 500,
          }
        },  
        {
          label: "Rules Name",
          name: "rules_name",
          sort: true,
        },
        {
          label: "Deducted Amount",
          name: "deducted_amount",
          sort: true,
        },     
        {
          label: "Probability",
          name: "probability",
          sort: true,
        },   
        {
          label: "Win Limit",
          name: "win_limit",
          sort: true,
        },      
        {
          label: "win limit per person",
          name: "win_limit_per_person",
          sort: true,
        },       
        {
          label: "Major Prize Id",
          name: "major_prizes_id_list",
          sort: true,
        },
        {
          label: "Campaign Identifier",
          name: "campaign_identifier",
          sort: true,
        },
         {
          label: "Last Login Date",
          name: "last_login_date",
          sort: true,
        },
        {
          label: "Input Count",
          name: "input_count",
          sort: true,
        },
        {
          label: "Default Slice Spin Wheel",
          name: "default_rule",
          slot_name: "default_rule_column",
          sort: true,
        },       
        {
          label: "Is Slice Free Spin",
          name: "is_slice_free_spin",
          slot_name: "is_slice_free_spin_column",
          sort: true,
        },
        {
          label: "Is Slice Try again",
          name: "is_slice_try_again",
          slot_name: "is_slice_try_again_column",
          sort: true,
        },                      
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.isBrandCodeDisabled = false;
    this.isPromoTypeDisabled = false;
    this.issubPromoTypeDisabled = false;
    this.mappingRole();
    this.onRefreshData();
    this.LoadTimezoneConfig();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('rulesconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('rulesconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    LoadTimezoneConfig() {
      api_loyalty.GetTimeZoneConfig(this.watch_brand_code).then((data) => {
        if (data.isSuccess) {
          this.TimeZoneConfigValue = data.data.value;
        }
      });
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.rulesModel = {
        brand_code: this.watch_brand_code,
        rules_name: "",
        promotion_type: "",
        sub_promotion_type: "",
        input_count: 0,
        deducted_amount: 0,
        probability: 0,
        win_limit: 0,
        win_limit_per_person: 0,
        target_refferal_count: 0,
        campaign_identifier:"",
        default_rule: false,
        default_rule_flag: 0,
        is_slice_free_spin: false,
        is_slice_free_spin_flag: 0,
        is_slice_try_again: false,
        is_slice_try_again_flag: 0,
        description: "",
        image_url: "",
        target_donation_amount: 0,
        flash_promo_id: "",
        addition_major_prizes_id_list:[],
        removal_major_prizes_id_list:[],
        last_login_date: new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        special_prize_condition_ids : [],
        grace_period: 0,
        group_outer: "",
        group_inner: "",
        outer_group_color: "",
        inner_group_color: "",
        icon_url: "",
        rank: 1
      };
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
      this.lastLoginDate = momStart;

      this.uploadModel = {
        image_url: "",
        imagePresignedUrl: "",
      };

      this.uploadIconModel = {
        icon_url: "",
        iconPresignedUrl: "",
      }

      this.isBrandCodeDisabled=false,
      this.isPromoTypeDisabled=false;
      this.issubPromoTypeDisabled=false;
      this.isLabelDoubleSpinWheelWarningShow=false;
      this.isInputCountShow= false;
      this.issub_promo_typeShow=false;
      this.isDeductionShow=true;
      this.isProbabilityShow=true;
      this.isWinLimitShow=true;
      this.isCampaignIdentifierShow=false;
      this.isLastLoginDateShow=false;
      this.isTargetRefferalCountShow = false;
      this.isWinLimitPerPersonShow=true;
      this.isDefaultRuleShow=false;
      this.isSliceFreeSpinShow=false;
      this.isSliceTryAgainShow=false;
      this.isInputSpecialPrizeShow=true;
      this.isTargetDonationAmountShow=false;
      this.isinputImageShow=false;
      this.isFlashPromoShow=false,
      this.isInputSpecialPrize=false;
      this.MajorPrizeValue = [];
      this.SpecialPrizeValues = [];
      this.unSelectSpecialPrizes = [];
      this.unSelectedMjrPrize = [],
      this.unSelectedMnrPrize = [],
      this.watch_promo_type = "";
      this.watch_sub_promo_type = "";
      this.isWinLimitDisabled = false;
      this.isCampaignIdentifierDisabled = false;
    },
    onCreateNewRules() {
      NProgress.start();
      api_loyalty
          .GetAllPrizesByBrandCode(this.rulesModel.brand_code)
          .then((data) => {
            if(data.isSuccess){
              var noRewardsContainer = [];
              this.MajorPrizesOption = data.data;
              this.MajorPrizesAllOption = data.data;

              data.data.forEach(function (item) {
                //6 is no reward prize type
                if(item.prize_type == "6"){
                  noRewardsContainer.push(item);
                }
              });
            
              this.MajorPrizesNoRewardOption = noRewardsContainer;
              NProgress.done();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      
        api_loyalty
          .GetAllSpecialPrizeConditionConfig(this.rulesModel.brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.SpecialPrizeOptions = data.data;
            }
            NProgress.done();
          })
          .catch((e) => {
            console.log(e);
          });

      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.isBrandCodeDisabled = false;
      this.isPromoTypeDisabled=false;
      this.issubPromoTypeDisabled=false;
      this.isLabelDoubleSpinWheelWarningShow=false;
      this.isEdit = false;
      this.onResetForm();
    },
    toggleActive() {},
    async onRefreshData() {

      if(this.showModalCreate){
        this.MajorPrizeValue = []
        NProgress.start();
        api_loyalty
          .GetAllPrizesByBrandCode(this.watch_brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.MajorPrizesOption = data.data;
              this.MajorPrizesAllOption = data.data;
              var noRewardsContainer = [];
              data.data.forEach(function (item)
              {
                //6 is no reward prize type
                if (item.prize_type == "6")
                {
                  noRewardsContainer.push(item);
                }
              });
              this.MajorPrizesNoRewardOption = noRewardsContainer;
              NProgress.done();
            }
          })
          .catch((e) => {
            console.log(e);
          });

          this.SpecialPrizeValues = [];
          api_loyalty
          .GetAllSpecialPrizeConditionConfig(this.rulesModel.brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.SpecialPrizeOptions = data.data;
              NProgress.done();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }

    api_loyalty
      .GetAllRules(this.watch_brand_code)
      .then((data) => {
        try {
          if(data.isSuccess){
              data.data.forEach(function (item){
                item.probability= item.probability.toLocaleString(undefined, { maximumFractionDigits: 7, minimumFractionDigits: 0 });
                switch(item.promotion_type){
                  case "0": item.promotion_type_name = "UGC Artwork Image"; break;
                  case "1": item.promotion_type_name = "UGC Artwork Image - Vote Approved"; break;
                  case "2": item.promotion_type_name = "Spin Wheel - Custom Prize"; break;
                  case "3": item.promotion_type_name = "UPC Input - Lifetime"; break;
                  case "4": item.promotion_type_name = "UPC Custom Insert"; break;
                  case "5": item.promotion_type_name = "MGM Major Prize"; break;
                  case "6": item.promotion_type_name = "MGM Minor Prize"; break;
                  case "7": item.promotion_type_name = "Custom Returnee"; break;
                  case "8": item.promotion_type_name = "Donations"; break;
                  case "9": item.promotion_type_name = "UPC Insert Regular"; break;
                  case "11": item.promotion_type_name = "Cash or Bukash"; break;               
                  case "12": item.promotion_type_name = "Progressive MGM"; break;
                  case "13": item.promotion_type_name = "Redeem Item"; break;
                  case "14": item.promotion_type_name = "Lucky Promo"; break;
                  case "15": item.promotion_type_name = "Roulette"; break;
                  case "16": item.promotion_type_name = "Daily Login"; break;
                  case "17": item.promotion_type_name = "Auto Awarding Birthday User"; break;
                  case "18": item.promotion_type_name = "Auto Awarding Anniversary"; break;
                  case "19": item.promotion_type_name = "Double SpinWheel"; break;
                  case "20": item.promotion_type_name = "Redeem Item On Event"; break;
                  case "25": item.promotion_type_name = "Daily Check In"; break;
                  case "30": item.promotion_type_name = "Beats Game"; break;
                  case "31": item.promotion_type_name = "Catch Game"; break;
                  case "40": item.promotion_type_name = "Chest Prize"; break;
                  case "45": item.promotion_type_name = "Lucky Promo With SKU"; break;
                  case "50": item.promotion_type_name = "UPC Custom Insert With Raffle"; break;
                }
            });
            this.rows = data.data;
            this.allRulesConfigs = data.data;
          }
          
        } catch (e) {
          console.log(e);
        }
    });
      //to get list data from flash promo configs
      api_loyalty
      .GetAllFlashPromoConfig(this.watch_brand_code)
      .then((data) => {
        try {
          if(data.isSuccess){
            this.FlashPromoConfigs = data.data;
            this.FlashPromoConfigs.push({ promotion_name: "[No Promo]", id: "" });
          }
        } catch (e) {
          this.FlashPromoConfigs.push({ promotion_name: "[No Promo]", id: "" });
          console.log(e);
        }
    });
      this.watch_promo_type= "";
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.rulesModel = Object.assign(
        this.rulesModel, 
        this.allRulesConfigs.find(
          (x) => x.id === this.selectedItems[0].id
        ) ?? {}
      );

      if(this.rulesModel.last_login_date == '0001-01-01T00:00:00'){
        this.rulesModel.last_login_date = new Date();
      }
       this.lastLoginDate = this.$moment(
        new Date(this.rulesModel.last_login_date)
      ).format("YYYY-MM-DD");

       var last_login_date = new Date(this.rulesModel.last_login_date);

      //ada perbedaan antara get tgl dr dynamo dan mysql.
      var hours = last_login_date.getHours() + parseInt(this.TimeZoneConfigValue) * 2;
      last_login_date.setHours(
        hours
      );
      this.lastLoginDate = last_login_date.toISOString();

      this.unSelectedMjrPrize = [],
      this.unSelectedMnrPrize = []
      this.showModalCreate = true;
      this.titlePopup = "Update";
      this.isBrandCodeDisabled = true;
      this.isPromoTypeDisabled = true;
      this.issubPromoTypeDisabled = true;
      this.watch_promo_type = this.rulesModel.promotion_type;
      this.watch_sub_promo_type = this.rulesModel.sub_promotion_type;
      

      let mjr_prizes = [];
      api_loyalty
          .GetAllPrizesByBrandCode(this.rulesModel.brand_code)
          .then((data) => {
            if(data.isSuccess){
              var noRewardsContainer = [];
              this.MajorPrizesOption = data.data;
              this.MajorPrizesAllOption = data.data;
              this.rulesModel.major_prizes_id_list.forEach(function (item) {
                var mjr_prize = data.data.filter((x) => x.id === item)[0];
                if(mjr_prize){
                  mjr_prizes.push(mjr_prize);
                }
              });            
              data.data.forEach(function (item) {
                //6 is no reward prize type
                if(item.prize_type == "6"){
                  noRewardsContainer.push(item);
                }
              });
            
              this.MajorPrizesNoRewardOption = noRewardsContainer;

              this.MajorPrizeValue = mjr_prizes;
            }
            
          })
          .catch((e) => {
            console.log(e);
          });

      let special_prizes = [];
      api_loyalty
          .GetAllSpecialPrizeConditionConfig(this.rulesModel.brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.SpecialPrizeOptions = data.data;
              this.rulesModel.special_prize_condition_id_list.forEach(function (item) {
                var special_prize = data.data.filter((x) => x.id === item)[0];
                if(special_prize){
                  special_prizes.push(special_prize);
                }
              });
              this.SpecialPrizeValues = special_prizes;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      this.isEdit = true;

      this.visiblityToggle(this.rulesModel.promotion_type);
      this.visiblityToggleForSubPromo(this.rulesModel.sub_promotion_type);

      if(this.rulesModel.is_slice_free_spin == 1 ){
        this.rulesModel.is_slice_free_spin = true
      }else{
        this.rulesModel.is_slice_free_spin = false
      }

      if(this.rulesModel.is_slice_try_again == 1 ){
        this.rulesModel.is_slice_try_again = true
      }else{
        this.rulesModel.is_slice_try_again = false
      }
      
      if(this.rulesModel.default_rule == true || this.rulesModel.default_rule == 1){
        this.rulesModel.default_rule = true;
        this.rulesModel.default_rule_flag = 1;
      }
      else{
        this.rulesModel.default_rule = false;
        this.rulesModel.default_rule_flag = 0
      }
      if(this.rulesModel.is_slice_free_spin == true){
          this.rulesModel.is_slice_free_spin_flag = 1;
      }
      else{
          this.rulesModel.is_slice_free_spin_flag = 0
      }
      if(this.rulesModel.is_slice_try_again == true){
          this.rulesModel.is_slice_try_again_flag = 1;
      }
      else{
          this.rulesModel.is_slice_try_again_flag = 0
      }
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.rulesModel.id = deleteRequest.id;
        this.rulesModel.brand_code = this.watch_brand_code;
        api_loyalty
          .DeleteGlobalPromoRules(this.rulesModel.brand_code, this.rulesModel)
          .then((response) => {
            this.onRefreshData();
            var popupType = "success"
            if(response.isSuccess == false){
            popupType = "danger";
            }

            let msg = {
              message:
                response.message + " : " + element.rules_name + "'.",
              type: popupType,
            };
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete rules '" +
                element.rules_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    async createUpdateRules() {
      if (this.lastLoginDate != null) {
        this.rulesModel.last_login_date = new Date(
          this.lastLoginDate
        ).toISOString();
      }

      if(this.rulesModel.default_rule == true){
          this.rulesModel.default_rule_flag = 1;
      }
      else{
          this.rulesModel.default_rule_flag = 0;
      }
      
      if(this.rulesModel.is_slice_free_spin == true){
          this.rulesModel.is_slice_free_spin_flag = 1;
      }
      else{
          this.rulesModel.is_slice_free_spin_flag = 0;
      }

      if(this.rulesModel.is_slice_try_again == true){
          this.rulesModel.is_slice_try_again_flag = 1;
      }
      else{
          this.rulesModel.is_slice_try_again_flag = 0;
      }
      let mjr_prz_items = [];
      this.MajorPrizeValue.forEach(function (item) {
          mjr_prz_items.push(item.id);
      });
      this.rulesModel.addition_major_prizes_id_list = mjr_prz_items;
      
      //compare id on removal list with addition list
      var compareRemovalMajorPrizeId = this.rulesModel.removal_major_prizes_id_list.filter(val => !this.rulesModel.addition_major_prizes_id_list.includes(val));
      this.rulesModel.removal_major_prizes_id_list = compareRemovalMajorPrizeId;

      let special_prize_items = [];
      this.SpecialPrizeValues.forEach(function (item) {
        special_prize_items.push(item.id);
      });
      this.rulesModel.special_prize_condition_ids = special_prize_items;
      if (this.rulesModel.id) 
       {
        this.rulesModel.modify_date = new Date().toISOString();
        this.rulesModel.brand_code = this.watch_brand_code;
        api_loyalty
        .UpdateGlobalPromoRules(this.rulesModel.brand_code, this.rulesModel)
        .then((response) => {
          this.onRefreshData();
          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 401)
          {
            this.message = {
              message: "You don't have a permission",
              type: 'danger'
            }
          } else
          {
            this.message = {
              message: "Failed to update rules Item Config.",
              type: "danger",
            }
          }          
        });
       }
       else
       {
          this.rulesModel.brand_code = this.watch_brand_code;
          this.rulesModel.create_date = new Date().toISOString();
          this.rulesModel.modify_date = new Date().toISOString();
          api_loyalty
          .AddGlobalPromoRules(this.rulesModel.brand_code, this.rulesModel)
          .then((response) => {
            this.onRefreshData();
            var popupType = "success"
            if(response.isSuccess == false){
              popupType = "danger";
            }

            this.message = {
              message: response.message,
              type: popupType,
            };
          })
          .catch((e) => {
            console.log(e);
            if (e.response && e.response.status === 401)
            {
              this.message = {
                message: "You don't have a permission",
                type: 'danger'
              }
            } else
            {
              this.message = {
                message: "Failed to create rules Item.",
                type: "danger",
              }
            }            
          });
        }

      if (this.uploadModel.imagePresignedUrl) {
        api_loyalty.S3PutObject(
          this.uploadModel.imagePresignedUrl,
          this.uploadModel.imageFile
        );
      }

      if (this.uploadIconModel.iconPresignedUrl)
      {
        api_loyalty.S3PutObject(
          this.uploadIconModel.iconPresignedUrl,
          this.uploadIconModel.iconFile
        );
      }

       this.onResetForm();
       this.showModalCreate = false;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (a) => {
        this.is_loads3presigned = true;
        this.uploadModel.imageFile = files[0];
        vm.uploadModel.image_url = a.target.result;
        let filenameIdentifier = this.rulesModel.id;
        if(!filenameIdentifier){
          filenameIdentifier = "id" + Math.random().toString(16).slice(2);
        }
        let filename = this.rulesModel.rules_name.replace(/[^A-Z0-9]/ig, "_") +  "_" + filenameIdentifier;
        api_loyalty
          .GenerateS3PresignedUploadUrl(
            "donations-catalog-image",
            files[0],
            filename,
            this.watch_brand_code
          )
          .then((data) => {
            try {
              if(data.isSuccess)
              {
                vm.uploadModel.imagePresignedUrl = data.data.s3Object.uploadUrl;
                this.rulesModel.image_url = data.data.s3Object.cdnUrl;
                console.log(vm.uploadModel.imagePresignedUrl);
              }
            } catch (e) {
              console.log(e);
            }
            this.is_loads3presigned = false;
          });
      };
      reader.readAsDataURL(files[0]);
    },
    onSelectIconChange(e)
    {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (a) =>
      {
        this.is_loads3presigned = true;
        this.uploadIconModel.iconFile = files[0];
        vm.uploadIconModel.icon_url = a.target.result;
        let filenameIdentifier = this.rulesModel.id;
        if (!filenameIdentifier)
        {
          filenameIdentifier = "id" + Math.random().toString(16).slice(2);
        }
        let filename = this.rulesModel.rules_name.replace(/[^A-Z0-9]/ig, "_") + "_" + filenameIdentifier;
        api_loyalty
          .GenerateS3PresignedUploadUrl(
            "img",
            files[0],
            filename,
            this.watch_brand_code
          )
          .then((data) =>
          {
            try
            {
              if(data.isSuccess)
              {
                vm.uploadIconModel.iconPresignedUrl = data.data.s3Object.uploadUrl;
                this.rulesModel.icon_url = data.data.s3Object.cdnUrl;
                this.rulesModel.icon = data.data.s3Object.cdnUrl;
                console.log(vm.uploadIconModel.iconPresignedUrl);
              }
            } catch (e)
            {
              console.log(e);
            }
            this.is_loads3presigned = false;
          });
      };
      reader.readAsDataURL(files[0]);
    },   
    isValidHexColor(value) {
      if (!value || typeof value !== "string") return false;
      var trimmed = value.trim();
      return /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(trimmed);
    },
    onGroupChange(){
      this.rulesModel.rules_name = this.rulesModel.group_outer + " - " + this.rulesModel.group_inner;
    },
    unSelectMjrPrize({id}){
      if(this.unSelectedMjrPrize.indexOf(id) == -1){
        this.unSelectedMjrPrize.push(id);
        this.rulesModel.removal_major_prizes_id_list.push(id);
      }
    },
    defaultInputValueForSubPromo(sub_promo_type){
      //for leaderboard winner rule, set the default value of win limit as 1
      //for Completion, set default value of rank as 0
      switch(sub_promo_type){
        case '6':
          this.rulesModel.win_limit = 1;
          break;
        case '8':
          this.rulesModel.rank = 0;
          break;
      }
    },
    visiblityToggleForSubPromo(sub_promo_type){
      this.isWinLimitDisabled = false;
      this.isWinLimitPerPersonDisabled = false;
      switch(sub_promo_type){
        case '0':
          this.isInputCountShow=false;
          break;
        case '1':
          this.isInputCountShow=true;
          break;
        case '2':
          this.isInputCountShow=false;
          this.isWinLimitPerPersonShow=true;
          break;
        case '3':
          this.isInputCountShow=true;
          this.isWinLimitPerPersonShow=false;
          break;
        case '6':
          this.isInputCountShow = false;
          this.isWinLimitDisabled = true;
          this.isWinLimitPerPersonDisabled = true;
          this.isRankShow = true;
          break;
        case '7':
          this.isInputCountShow = false;
          this.isWinLimitPerPersonDisabled = true;
          this.isRankShow = true;
          break;
        case '8':
          this.isInputCountShow = false;
          this.isWinLimitPerPersonDisabled = false;
          this.isRankShow = false;
          break;
      }
    },   
    visiblityToggle(promo_type){
      // set grace period dan iswinlimitperpersondisabled default karna hanya relevan terhadap promo anniverasary
      // selain promo anniversary grace period harus false dan iswinlimitperpersondisabled harus false
      this.isGracePeriodShow = false;
      this.isWinLimitDisabled = false;
      this.isWinLimitPerPersonDisabled = false;

      // set default untuk semua
      this.isDeductionShow=false;
      this.isInputSpecialPrizeShow=false;
      this.isProbabilityShow=false;
      this.isWinLimitShow=true;
      this.isCampaignIdentifierShow=false;
      this.isLastLoginDateShow=false;
      this.isTargetRefferalCountShow = false;
      this.isWinLimitPerPersonShow=false;
      this.isDefaultRuleShow=false;
      this.isSliceFreeSpinShow=false;
      this.isSliceTryAgainShow=false;
      this.isTargetDonationAmountShow=false;
      this.isinputImageShow=false;
      this.isinputPrizeShow=false;
      this.issub_promo_typeShow=false;
      this.isInputCountShow=false;
      this.isFlashPromoShow=false;             
      this.isGroupOuterShow = false;
      this.isGroupInnerShow = false;
      this.isGroupOuterColorShow = false;
      this.isGroupInnerColorShow = false;
      this.isSelectIconShow = false;
      this.isLabelDoubleSpinWheelWarningShow = false;
      this.isRankShow = false;
      
      switch(promo_type){
        case '0':
        case '1':
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          break;
        case '2':
          this.isDeductionShow=true;
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isDefaultRuleShow=true;
          this.isinputPrizeShow=true;
          this.isSliceFreeSpinShow=true;
          this.isSliceTryAgainShow=true;
          break;
        case '3':
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          break;
        case '4':
          this.isWinLimitShow=true;
          this.isCampaignIdentifierShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          break;     
        case '5':
          this.isWinLimitShow=true;
          this.isTargetRefferalCountShow = true;
          this.isinputPrizeShow=true;
          break;
        case '6':
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          break;
        case '7':
          this.isWinLimitShow=true;
          this.isCampaignIdentifierShow=true;
          this.isLastLoginDateShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          break;
        case '8':
          this.isDeductionShow=true;
          this.isinputImageShow=true;
          break;
        case '9':
          this.isInputSpecialPrizeShow=true;
          this.isinputPrizeShow=true;
          this.issub_promo_typeShow=true;
          break;
        case '11':
          this.isDeductionShow=true;
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isSliceTryAgainShow=true;
          this.isinputPrizeShow=true;
          break;
        case '13':
          this.isDeductionShow=true;
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          this.isFlashPromoShow=true;
          break;
        case '12':
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          this.issub_promo_typeShow=true;
          break;
        case '14':
          this.isDeductionShow = false;
          this.isInputSpecialPrizeShow = false;
          this.isProbabilityShow = false;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.issub_promo_typeShow = false;
          this.isInputCountShow = false;
          this.isFlashPromoShow = false;
          this.isGracePeriodShow = false;
          this.isWinLimitPerPersonDisabled = false;
          this.isGroupOuterShow = false;
          this.isGroupInnerShow = false;
          this.isRankShow = false;
          this.isSelectIconShow = false;
          this.isLabelDoubleSpinWheelWarningShow = false;
          break;
        case '15':
          this.isDeductionShow=true;
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isSliceTryAgainShow=true;
          this.isinputPrizeShow=true;
          break;
        case '16':
        case '25':
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isWinLimitPerPersonShow=true;
          this.isinputPrizeShow=true;
          this.issub_promo_typeShow=true;
          this.isInputCountShow=true;
          break;
        case '17':
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.isGracePeriodShow = true;
          this.isWinLimitPerPersonDisabled = true;
          break;
        case '18':
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.isGracePeriodShow = true;
          this.isWinLimitPerPersonDisabled = true;
          break;
        case '19':
          this.isDeductionShow = true;
          this.isProbabilityShow = true;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.isGroupOuterShow = true;
          this.isGroupInnerShow = true;
          this.isGroupOuterColorShow = true;
          this.isGroupInnerColorShow = true;
          this.isSelectIconShow = true;
          this.isLabelDoubleSpinWheelWarningShow = true;
          break;
          case '20':
          this.isDeductionShow = true;
          this.isProbabilityShow = true;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          break;
        case '30':
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.issub_promo_typeShow = true;
          this.isWinLimitPerPersonDisabled = true;
          break;
        case '31':
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.issub_promo_typeShow = true;
          this.isWinLimitPerPersonDisabled = true;
          this.isRankShow = true;
          break;
        case '40':
          this.isDeductionShow = true;
          this.isProbabilityShow = true;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isSliceTryAgainShow = true;
          this.isinputPrizeShow = true;
          this.isInputCountShow = true;
          this.isGroupOuterShow = true;
          break;
        case '45':
          this.isDeductionShow = false;
          this.isInputSpecialPrizeShow = false;
          this.isProbabilityShow = false;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isinputPrizeShow = true;
          this.issub_promo_typeShow = false;
          this.isInputCountShow = false;
          this.isFlashPromoShow = false;
          this.isGracePeriodShow = false;
          this.isWinLimitPerPersonDisabled = false;
          this.isGroupOuterShow = false;
          this.isGroupInnerShow = false;
          this.isRankShow = false;
          this.isSelectIconShow = false;
          this.isLabelDoubleSpinWheelWarningShow = false;
          break;
        case '50':
          this.isProbabilityShow = true;
          this.isWinLimitShow = true;
          this.isWinLimitPerPersonShow = true;
          this.isCampaignIdentifierShow = true;
          this.isDefaultRuleShow = true;
          this.isinputPrizeShow = true;
          break;
        default:
          this.isDeductionShow=false;
          this.isInputSpecialPrizeShow=false;
          this.isProbabilityShow=true;
          this.isWinLimitShow=true;
          this.isCampaignIdentifierShow=false;
          this.isTargetRefferalCountShow = false;
          this.isWinLimitPerPersonShow=true;
          this.isDefaultRuleShow=false;
          this.isSliceFreeSpinShow=false;
          this.isSliceTryAgainShow=false;
          this.isTargetDonationAmountShow=false;
          this.isinputImageShow=false;
          this.isinputPrizeShow=true;
          this.issub_promo_typeShow=false;
          this.isInputCountShow=false;
          this.isFlashPromoShow=false;
          this.isGracePeriodShow = false;
          this.isWinLimitPerPersonDisabled = false;
          this.isGroupOuterShow = false;
          this.isGroupInnerShow = false;
          this.isGroupOuterColorShow = false;
          this.isGroupInnerColorShow = false;
          this.isRankShow = false;
          this.isSelectIconShow = false;
          this.isLabelDoubleSpinWheelWarningShow = false;
          break;
      }
    },

    restrictDecimal () {
      var inputDecimal = String(this.rulesModel.probability).match(/^\d+\.?\d{0,7}/);
      if(inputDecimal){
        this.rulesModel.probability= String(inputDecimal[0]);
      }
    },
     isPrizeTypeNoReward: function(val){
      if(val === true){
        this.MajorPrizesOption = this.MajorPrizesNoRewardOption;
        this.rulesModel.default_rule = true;
      }
      else{
        this.MajorPrizesOption = this.MajorPrizesAllOption;
        this.rulesModel.default_rule = false;
      }
    },
    validateInputCountDailyLogin() {
      if (this.rulesModel.input_count < 1) {
        this.rulesModel.input_count = 1;
      }
    },
    limitGracePeriod()
    {
      this.rulesModel.grace_period = Math.min(30, Math.max(0, this.rulesModel.grace_period));
    },
    setMaxValue(promo_type) {      
      this.rulesModel.win_limit = 0;
      this.rulesModel.win_limit_per_person = 0;
      
      switch(promo_type) {
        case '50':
          //hardcoded win or lose, because coin will be given even if user is lose
          //the field is not editable
          this.rulesModel.win_limit = 2147483647;
          this.rulesModel.win_limit_per_person = 2147483647;
          break;
        default:
          break;
      }
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    Multiselect,
    // BaseCheckbox,
  },
  watch: {
    watch_brand_code: function(val) {
      this.rulesModel.brand_code = this.watch_brand_code;
      switch (val) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
      this.onRefreshData();
    },
    watch_promo_type: function (val) {
      this.rulesModel.promotion_type = val;
      if( this.isEdit == false){
        this.rulesModel.default_rule = false;
        this.rulesModel.is_slice_free_spin = false;
        this.rulesModel.is_slice_try_again = false;
        this.rulesModel.deducted_amount = 0;
        this.rulesModel.campaign_identifier = "";
        this.watch_sub_promo_type = "";
        this.rulesModel.win_limit = 0;
        this.isPrizeTypeNoReward(false);
      }
      this.isEdit = false;

      if(this.rulesModel.promotion_type == '8'){
        this.MajorPrizeValue = [];
      }
      if(this.rulesModel.promotion_type == '9'){
        this.isTargetDonationAmountShow=false;
        this.isInputCountShow=false;
        this.isInputSpecialPrizeShow=true;
      }
      if(this.rulesModel.promotion_type == '12'){
        this.isInputCountShow=false;
      }
      if (this.rulesModel.promotion_type == '16' || this.rulesModel.promotion_type == '25') {
        if (this.MajorPrizeValue.length > 0) {
          this.MajorPrizeValue = this.MajorPrizeValue.length > 1 ? [this.MajorPrizeValue[0]] : this.MajorPrizeValue
        }
      }

      if (this.rulesModel.promotion_type == '17' ||
        this.rulesModel.promotion_type == '18')
      {
        this.rulesModel.win_limit_per_person = 1;
        this.rulesModel.probability = 100;
      }

      if (this.rulesModel.promotion_type == '30' ||
        this.rulesModel.promotion_type == '31')
      {
        this.rulesModel.win_limit_per_person = 1;
      }
      
      if(this.rulesModel.sub_promotion_type == '1'){
        this.isInputCountShow=true;
      }
      if(this.rulesModel.sub_promotion_type == '0'){
        this.isInputCountShow=false;
      }      
      if(this.rulesModel.promotion_type == '40'){
        this.groupOuterLabel = "Group";
      } 
      else {
        this.groupOuterLabel = "Group Outer";
      }
      this.visiblityToggle(this.rulesModel.promotion_type);

      var sub_Promo_type_items = []
      this.allsubPromoType.forEach(function (item) {
        if(item.promotype.indexOf(val) !== -1){
          sub_Promo_type_items.push(item);
        }
      });
      this.selectedSubPromoType = sub_Promo_type_items;
    },
    watch_sub_promo_type: function (val) {
      this.rulesModel.sub_promotion_type = val;
      this.defaultInputValueForSubPromo(this.rulesModel.sub_promotion_type);
      this.visiblityToggleForSubPromo(this.rulesModel.sub_promotion_type);
    },
    MajorPrizeValue: function (val) {
      if (this.rulesModel.promotion_type == '16' || this.rulesModel.promotion_type == '25') {
        if (val.length > 0) {
          this.MajorPrizeValue = val.length > 1 ? [val[val.length - 1]] : val
        }
      }
    },
    'rulesModel.default_rule': function (val) {
      if (this.rulesModel.promotion_type == '50') {
        this.isWinLimitDisabled = val;
        this.isWinLimitPerPersonDisabled = val;
        this.isCampaignIdentifierDisabled = val;
        if (val) {
          this.rulesModel.campaign_identifier = "";
          this.setMaxValue(this.rulesModel.promotion_type);
        }
        else {
          if (!this.rulesModel.win_limit) {
            this.rulesModel.win_limit = 0;
          }
          if (!this.rulesModel.win_limit_per_person) {
            this.rulesModel.win_limit_per_person = 0;
          }
        }
      }
    }
  },
 
  computed: {
    disableButtonSubmit: function () {
      let isDisabled = true;
      let mainFieldFilled = false;
      if(this.rulesModel.rules_name && this.rulesModel.brand_code && this.rulesModel.promotion_type){
        if(this.rulesModel.promotion_type == '50') {
          if(this.MajorPrizeValue.length > 0 && 
          this.rulesModel.default_rule == false && 
          this.rulesModel.campaign_identifier == "") {
            mainFieldFilled = false
          }
          else {
            mainFieldFilled = true
          }
        }
        else {
          mainFieldFilled = true
        }
      }
       //for promotion type "Donation"
       if(mainFieldFilled && this.rulesModel.promotion_type == '8' && this.rulesModel.target_donation_amount > 0){
          isDisabled = false;
       }

       //for promotion type other than "Donation"
       if(mainFieldFilled && this.rulesModel.promotion_type != '8' && this.MajorPrizeValue.length > 0){
          isDisabled = false;
       }

       // Check if group outer and inner is valid hex and not null
       if (!isDisabled && this.isGroupOuterColorShow) {
         const outer = this.rulesModel.outer_group_color && this.rulesModel.outer_group_color.trim();
         if (!outer || !this.isValidHexColor(outer)) isDisabled = true;
       }
       if (!isDisabled && this.isGroupInnerColorShow) {
         const inner = this.rulesModel.inner_group_color && this.rulesModel.inner_group_color.trim();
         if (!inner || !this.isValidHexColor(inner)) isDisabled = true;
       }
       
      return isDisabled;
    },
    isGroupColorHexWarning: function() {
      if (!this.isGroupOuterColorShow && !this.isGroupInnerColorShow) return false;
      if (this.isGroupOuterColorShow) {
        var outer = this.rulesModel.outer_group_color && this.rulesModel.outer_group_color.trim();
        if (!outer || !this.isValidHexColor(outer)) return true;
      }
      if (this.isGroupInnerColorShow) {
        var inner = this.rulesModel.inner_group_color && this.rulesModel.inner_group_color.trim();
        if (!inner || !this.isValidHexColor(inner)) return true;
      }
      return false;
    },
    isNoRewardGroupValue: function(){
      if(this.rulesModel.is_slice_free_spin == true ||
        this.rulesModel.is_slice_try_again == true)
      {
        return true;
      }
      else{
        return false;
      }
    },
    defaultRuleLabel: function() {
      if (this.rulesModel.promotion_type == '50') {
        return 'Default Rule';
      }
      return 'Default Slice Spin Wheel';
    },
    defaultRuleDescription: function() {
      if (this.rulesModel.promotion_type == '50') {
        return '(applicable to all campaign identifier rule)';
      }
      return '(only applicable for Promo Type Spin Wheel Custom Prize)';
    }
  }
};
</script>
<style>
</style>

